import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import "./addSlider.css";
import { deleteSlider, getSlider } from "../../api/slider";
import LoadingPage from "../Loading/loading";
import { proxy } from "../../config";
import { Link } from "react-router-dom";
import { Cookies } from "react-cookie";

const SliderComponent = (props) => {
  const [sliders, setSliders] = useState(null);
  const [id, setId] = useState("");

  useEffect(() => {
    setSliders(null);
    getSlider(props.user).then((result) => {
      setSliders(result.data.response);
    });
  }, []);

  const sliderDelete = (id) => {
    deleteSlider(id).then((result) => {
      setSliders(sliders.filter((slider) => slider._id !== id));
    });
  };

  return (
    <>
      {sliders === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="card-cards">
            {sliders?.map((slider) => (
              <div key={slider._id} className={`card-card`}>
                <div
                  className="card-info"
                  style={{
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <img
                      className="image-slider"
                      src={`${proxy}/${slider.image}`}
                    />
                    {id === slider._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to delete this slider?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setId("");
                              }}
                              className="action-btn accept-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                sliderDelete(slider._id);
                              }}
                              className="action-btn remove-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {id !== slider._id && (
                  <div className="card-actions">
                    {slider.link !== "" && (
                      <Link
                        target="_blanck"
                        to={slider.link}
                        className={`action-btn accept-btn`}
                      >
                        link
                      </Link>
                    )}
                    {props.isSuper && (
                      <button
                        onClick={() => {
                          setId(slider._id);
                        }}
                        className="action-btn remove-btn"
                      >
                        Delete
                      </button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SliderComponent;
